
const urlParams = new URL(document.currentScript.src);
const params = new URLSearchParams(urlParams.search);
const vapidPublicKey = params.get('vapidPublicKey');

if ('serviceWorker' in navigator && 'PushManager' in window && vapidPublicKey) {
    Notification.requestPermission().then(function (permission) {
        if (permission === 'granted') {
            return navigator.serviceWorker.ready.then(function (registration) {
                return registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: vapidPublicKey
                });
            });
        }
    }).then(function (subscription) {
        sendTokenToServer(subscription);
    })
    .catch(function (error) {
        console.error('Erro ao registrar o Service Worker ou solicitar permissão de notificações:', error);
    });
}

function sendTokenToServer(token) {
    fetch(Benner.Page.getApplicationPath() + `api/v1/tec/pushnotification/token`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(token),
    })
}